export function WeldingSpecialists() {
  return <img src="/img/welding_specialists.png" style={{ maxWidth: "100%", maxHeight: "100%" }} />;
}
